<template>
    <div v-bind:class="{'notedited': !edited_dev_type['edit'] , 'collapsible-body': edited_dev_type['id']}">
        <div class="row" style="width: 100%;">
            <div class="col s3">
                <template v-if="edited_dev_type.photo != null && edited_dev_type.photo != undefined">
                    <v-lazy-image v-bind:src="edited_dev_type.photo" src-placeholder="/nofoto.png" width="200" />
                </template>
                <input type="file" id="input" @change="setImageFile(edited_dev_type, $event.target.name, $event.target.files)" v-if="edited_dev_type.edit">
            </div>
            <div class="col s9">
                <div class="row" style="width: 100%;">
                    <div class="col s1 rightlabel">
                        {{$t('dev_types.name')}}
                    </div>
                    <div class="col s6">
                        <div class="input-field">
                            <input :id="'devtypename' + (edited_dev_type.id || 'new')" type="text" placeholder="" v-model="edited_dev_type.name" :disabled="edited_dev_type.edit == false" />
                        </div>
                    </div>
                    <div class="col s2 rightlabel">
                        {{$t('dev_types.prefix')}}</div>
                    <div class="col s2">
                        <div class="input-field inline"><input :id="'devtypeprefix' + (edited_dev_type.id || 'new')"  type="text" placeholder="" v-model="edited_dev_type.prefix" :disabled="edited_dev_type.edit == false" /></div>
                    </div>
                    <div class="col s1" v-if="edited_dev_type.editable">
                        <a class="waves-effect waves-light btn-small red"  v-bind:class="{'opaquebutton': (edited_dev_type.total > 0)}" v-on:click="removeDevType(edited_dev_type)" v-bind:title="deleteTitle">{{$t('menu.buttons.delete')}}</a>
                    </div>
                </div>
                <div class="row" style="width: 100%;">
                    <div class="col s4 rightlabel">
                        {{$t('dev_types.device_category')}}
                    </div>
                    <div class="col s8" style="padding-right: 5px;" v-if="edited_dev_type.id != undefined">
                        <select :id="'devtypecategory' + (edited_dev_type.id || 'new')" v-model="edited_dev_type.device_category_id" :disabled="true">
                            <option v-for="dc in device_categories" :value="dc.id">{{dc.name}}</option>
                        </select>
                         {{errors.device_category ? errors.device_category[0] : ""}}
                    </div>
                    
                    <div class="col s8" style="padding-right: 5px;" v-else>
                        <select :id="'devtypecategory' + (edited_dev_type.id || 'new')"  v-model="edited_dev_type.device_category_id" :disabled="edited_dev_type.edit == false">
                            <option v-for="dc in device_categories" :value="dc.id">{{dc.name}}</option>
                        </select>
                         {{errors.device_category ? errors.device_category[0] : ""}}
                    </div>
                </div>
                
                <div class="row" style="width: 100%;">
                    <div class="col s4 rightlabel">
                        {{$t('dev_types.substances')}}
                    </div>
                    <div class="col s8">
                        <selector v-model="edited_dev_type.substance_ids" :items="substances" :elongating="true" :identifier="'substancesfordt'+edited_dev_type.id" :disabled="edited_dev_type.edit == false"></selector>
                    </div>
                </div>
                <div class="row" style="width: 100%;">
                    <div class="col s4 rightlabel">{{$t('dev_types.pest_group')}}</div>
                    <div class="col s8">
                        <selector v-model="edited_dev_type.group_ids" :items="pestgroups" :identifier="'groupdfordt'+edited_dev_type.id" :elongating="true" :disabled="edited_dev_type.edit == false"></selector>
                    </div>
                </div>
                <div class="row" style="width: 100%;">
                    <div class="col s4 rightlabel">{{$t('dev_types.zone')}}</div>
                    <div class="col s8" style="padding-right: 5px;">
                        <select :id="'devtypezone' + (edited_dev_type.id || 'new')"  v-model="edited_dev_type.zone" :disabled="edited_dev_type.edit == false" style="padding-right: 5px;">
                            <option value="inner">{{$t('dev_types.inner')}}</option>
                            <option value="outer">{{$t('dev_types.outer')}}</option>
                            <option value="inner_outer">{{$t('dev_types.inner_outer')}}</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" style="margin-top: 16px;">
            <div class="col s12">
                <h6>{{$t('dev_types.maintenaces')}}</h6>
                <template  v-for="(maintenace,index) in edited_dev_type.maintenaces_attributes">
                    <div class="row" style="margin-top: 16px;" v-if="maintenace.active">
                        <div class="col s1 input-field inline rightlabel">{{$t('dev_types.maintenace_name')}}</div>
                        <div class="col s3 input-field inline"><input :id="'devtypecategory' + (edited_dev_type.id || 'new')+'maintenacetext'+index" v-model="maintenace.text" :disabled="edited_dev_type.edit == false" /></div>
                        <div class="col s1 input-field inline rightlabel">{{$t('dev_types.symbol')}}</div>
                        <div class="col s2 input-field inline"><input :id="'devtypecategory' + (edited_dev_type.id || 'new')+'maintenacesymbol'+index" v-model="maintenace.symbol" :disabled="edited_dev_type.edit == false" /></div>
                        <div class="col s2 input-field inline">
                            <label>
                                <input :id="'devtypecategory' + (edited_dev_type.id || 'new')+'maintenacerepeat'+index" type="checkbox" v-model="maintenace.repeat" :disabled="edited_dev_type.edit == false" />
                                <span style="color: black;">{{$t('dev_types.repeat')}}</span>
                            </label>
                        </div>
                        <div class="col s2 input-field inline" v-if="maintenace.repeat">
                            {{$t('dev_types.every')}} <input :id="'devtypecategory' + (edited_dev_type.id || 'new')+'maintenaceinterval'+index" type="number" v-model="maintenace.interval" min="1" :disabled="edited_dev_type.edit == false" style="width: inherit;"/> {{$t('dev_types.days')}}
                        </div>
                        <div class="col s1" v-if="edited_dev_type.edit">
                            <a class="waves-effect waves-light btn-small red" v-on:click="removeMaintenace(maintenace)">{{$t('menu.buttons.delete')}}</a>
                        </div>
                    </div>
                </template>
                <a class="waves-effect waves-light btn-small emptygreen green" v-on:click="edited_dev_type.maintenaces_attributes.push({'repeat': false, 'interval': 1, 'active': true})" v-if="edited_dev_type.edit">{{$t('dev_types.add_maintenace')}}</a>
            </div>
        </div>
        <div class="row" style="margin-top: 16px;" v-if="edited_dev_type.editable">
            <div class="col offset-l10 s4 l2" v-if="edited_dev_type.edit == false" style="text-align: right;"><a class="waves-effect waves-light btn-large emptygreen" v-on:click="editDevType(edited_dev_type)" v-if="edited_dev_type.edit == false">{{$t('menu.buttons.edit')}}</a></div>
            <div class="col  offset-l8 s4 l2" v-if="edited_dev_type.edit" style="text-align : right;"><a class="waves-effect waves-light btn-large cancelbutton" v-on:click="unEditDevType(edited_dev_type)" v-if="edited_dev_type.edit"> {{$t('menu.buttons.cancel_changes')}}</a></div>
            <div class="col l2 s4" v-if="edited_dev_type.edit" style="text-align: right; ">
                <a style="width: 100%;" class="waves-effect waves-light btn-large emptygreen" v-on:click="saveDevType(edited_dev_type)" v-if="edited_dev_type.edit">
                    <div v-if="saving" class="preloader-wrapper small active">
                        <div class="spinner-layer spinner-red-only">
                            <div class="circle-clipper left">
                                <div class="circle"></div>
                            </div>
                            <div class="gap-patch">
                                <div class="circle"></div>
                            </div>
                            <div class="circle-clipper right">
                                <div class="circle"></div>
                            </div>
                        </div>
                    </div>
                    {{saving == false ? $t('menu.buttons.save_changes') : ""}}
                </a>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
export default {
    data: function() {
        return {
            order: 1,
            orderby: 'number',
            customers: [],
            saving: false,
            edited_dev_type: {},
            errors: {}
        }
    },
    props: { dev_type: Object, device_categories: Array, substances: Array, pestgroups: Array, extended_privileges: Boolean },
    created() {
       
    },
    mounted(){
        this.edited_dev_type = _.cloneDeep(this.dev_type);
        this.edited_dev_type.maintenaces_attributes = this.edited_dev_type.maintenaces;
         if (_.isUndefined(this.edited_dev_type.media)) {
            this.edited_dev_type.media = []
            this.edited_dev_type.media.push({ "image": "" });
        }
    },
    computed: {
        deleteTitle() {
            if (this.edited_dev_type.total > 0) {
              return this.$t('dev_types.delete_disabled', {
                n: this.edited_dev_type.total
              })
            }

            return this.$t('menu.buttons.delete')
          }
    },
    methods: {

        collapse: function(customer) {
            customer.collapsed = !(customer.collapsed);
            this.$forceUpdate();
        },
        setImageFile: async function(doc, name,file){
          const toBase64 = file => new Promise((resolve, reject) => {
              const reader = new FileReader();
              reader.readAsDataURL(file);
              reader.onload = () => resolve(reader.result);
              reader.onerror = error => reject(error);
          });
          const result = await toBase64(file[0]).catch(e => Error(e));
          if (result instanceof Error) {
              console.log('Error: ', result.message);
              return;
          }
          doc.photo = result;
          if(doc.media.length == 0) doc.media.push({image: ""});
          doc.media[0].image = file[0];
          this.$forceUpdate();
        },
        editDevType: function(edited_dev_type) {
            edited_dev_type.edit = true;
            this.$forceUpdate();
        },
        unEditDevType: function(edited_dev_type, rd) {
            if (edited_dev_type.id != undefined) {
                edited_dev_type.edit = false;
                if(rd != null) {
                    if(edited_dev_type.maintenaces != undefined){
                        edited_dev_type.maintenaces = _.cloneDeep(rd.maintenaces);
                    
                    }
                    if(edited_dev_type.maintenaces_attributes != undefined){
                         edited_dev_type.maintenaces_attributes = _.cloneDeep(rd.maintenaces_attributes)
                    }
                }
                this.$forceUpdate();
            } else {
                this.$emit('cancelDevType')
            }
        },

        saveDevType: function(dev_type) {
            var that = this;
            const formData = new FormData();
            for (var key of Object.keys(dev_type)) {
                var blacklisted = (key == 'photo' && dev_type.id != undefined) || key == 'group_ids' || key == 'substance_ids';
                console.log(key, dev_type[key] ,blacklisted)

                if (key != 'maintenaces_attributes' && !blacklisted) {
                    formData.append('dev_type[' + key + ']', dev_type[key]);
                }
            }
            var i = 0;
            for (var reco of dev_type.maintenaces_attributes) {
                for (var key of Object.keys(reco)) {
                    formData.append('dev_type[maintenaces_attributes][' + i + '][' + key + ']', reco[key]);
                }
                if (reco.destroy) {
                    formData.append('dev_type[maintenaces_attributes][' + i + '][_destroy]', true);
                }
                i += 1;
            }
            var i = 0;
            for (var reco of dev_type.media) {
                if (reco.image != "") {
                for (var key of Object.keys(reco)) {
                        formData.append('dev_type[media_attributes][' + i + '][' + key + ']', reco[key]);
                    }
                }
                if (reco.destroy) {
                    formData.append('dev_type[media_attributes][' + i + '][_destroy]', true);
                }
                i += 1;
            }
            dev_type.group_ids.forEach((group_id, index) => {
              formData.append('dev_type[group_ids][]', group_id);
            });
            dev_type.substance_ids.forEach((group_id, index) => {
              formData.append('dev_type[substance_ids][]', group_id);
            });
            if (_.isUndefined(dev_type.id)) {
                var that = this;
                axios.post('/dev_types.json', formData).then(response => {
                    dev_type.id = response.data.id;
                    that.$emit('addDevType', dev_type)
                    this.unEditDevType(dev_type);
                }).catch(function(error) {
                    that.errors = error.response.data;
                    that.$forceUpdate();
                  });
            } else {
                axios.put('/dev_types/' + dev_type.id + '.json', formData).then(response => {
                    this.unEditDevType(dev_type, response.data);
                });
            }
        },
        removeDevType: function(dev_type) {
            if(dev_type.total > 0) return 0;
            this.$emit('removeDevType', dev_type);
        },
        removeMaintenace: function(maintenace){
            if (maintenace.id != undefined) {
                maintenace.active = false;
            } else {
                this.edited_dev_type.maintenaces_attributes.splice(this.edited_dev_type.maintenaces_attributes.indexOf(maintenace),1)
            }
        }
    },

}
</script>
<style scoped>
.login_button {
    color: red;
}

p {
    font-size: 2em;
    text-align: center;
}

nav {
    background-color: #626262;
    height: 100px;
}

nav a {
    margin: 15px;
}

.settingsform .btn-large {
    border-radius: 8px;
    background-color: white;
    color: black;
    border-color: #00CC66;
    border-width: 1px;
    border-style: solid;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.solidgreen {
    background-color: #00CC66 !important;
}

select {
    display: block;
    background-color: white !important;
    border-radius: 4px !important;
    border-width: 1px !important;
    border-style: solid !important;
    border-color: rgb(140, 140, 140) !important;
    padding-left: 5px !important;
    height: 35px !important;
}

.btn-small {
    color: black;
    border-radius: 8px;
}

.red {
    background-color: #C22026 !important;
    border-color: #C22026 !important;
}

.col {
    line-height: 1.5;
}
.opaquebutton {
    opacity: 0.5;
}
</style>